var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"labeled-status-badge"},[_c('span',{staticClass:"labeled-status-badge__label"},[_vm._v(_vm._s(_vm.label)+":")]),_c('b-badge',{staticClass:"labeled-status-badge__value",class:`labeled-status-badge__value--${_vm.variant}`,attrs:{"pill":""}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }